import { LogLevel } from '@Common/Enums';
import instances from '@InstanceFactory';
import { enumerable } from './CoreDecorator';

export class DashboardSettings {
    @enumerable
    public static get settings(): instances.DashboardSettings {
        return altosoft.model.dashboardSettings || instances.DashboardSettings.create();
    }

    public static isLogNavigation(): boolean {
        return this.settings.logLevel.hasFlag(LogLevel.navigation);
    }
}
